/* eslint-disable id-length */
import api from '#config/api';

export const createAdelphiSpiritReduction = values => api.post('/spirit-reductions', values);

export const getAllAdelphiSpiritReductions = () => api.get('/spirit-reductions');

export const getAdelphiSpiritReductionById = id => api.get(`/spirit-reductions/${id}`);

export const updateAdelphiSpiritReductionById = ({ id, values }) =>
  api.put(`/spirit-reductions/${id}`, values);
